export const mapBlockedTimesToEvents = (blockedTimes, options = {}) => {
  const normalizeCalendarTime = (timeValue, fallback) => {
    if (!timeValue || typeof timeValue !== 'string') {
      return fallback;
    }
    const trimmed = timeValue.trim();
    if (/^\d{2}:\d{2}$/.test(trimmed)) {
      return `${trimmed}:00`;
    }
    if (/^\d{2}:\d{2}:\d{2}$/.test(trimmed)) {
      return trimmed;
    }
    return fallback;
  };

  const fullDayStartTime = normalizeCalendarTime(options.slotMinTime, '07:00:00');
  const fullDayEndTime = normalizeCalendarTime(options.slotMaxTime, '20:00:00');

  return blockedTimes
    .filter(b => b.je_aktivny)
    .map(blocked => {      
      let startTime = blocked.zaciatok;
      let endTime = blocked.koniec;
      
      if (blocked.typ_blokovania === 'cely_den') {
        const startDate = blocked.zaciatok.split(' ')[0];
        return {
          id: `blocked-${blocked.id}`,
          title: `${blocked.nazov}`,
          start: `${startDate} ${fullDayStartTime}`,
          end: `${startDate} ${fullDayEndTime}`,
          allDay: false,
          display: 'block',
          className: options.className || 'blocked-event',
          classNames: options.classNames || ['blocked-event'],
          extendedProps: {
            type: 'blocked',
            data: blocked,
            isBlocked: true,
            isAllDayBlocking: true,
            ...(options.extendedProps || {})
          }
        };
      } else if (blocked.typ_blokovania === 'viacero_dni') {
        const startParts = blocked.zaciatok.split(' ')[0].split('-');
        const endParts = blocked.koniec.split(' ')[0].split('-');
        
        const startDate = new Date(parseInt(startParts[0]), parseInt(startParts[1]) - 1, parseInt(startParts[2]));
        const endDate = new Date(parseInt(endParts[0]), parseInt(endParts[1]) - 1, parseInt(endParts[2]));
        
        if (blocked.koniec.includes('00:00:00')) {
          endDate.setDate(endDate.getDate() - 1);
        }
        
        const events = [];
        const currentDate = new Date(startDate);
        
        while (currentDate <= endDate) {
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const dateStr = `${year}-${month}-${day}`;
          
          events.push({
            id: `blocked-${blocked.id}-${dateStr}`,
            title: `${blocked.nazov}`,
            start: `${dateStr} ${fullDayStartTime}`,
            end: `${dateStr} ${fullDayEndTime}`,
            allDay: false,
            display: 'block',
            className: options.className || 'blocked-event',
            classNames: options.classNames || ['blocked-event'],
            extendedProps: {
              type: 'blocked',
              data: blocked,
              isBlocked: true,
              isAllDayBlocking: true,
              ...(options.extendedProps || {})
            }
          });
          currentDate.setDate(currentDate.getDate() + 1);
        }
        
        return events;
      } else if (blocked.typ_blokovania === 'opakujuce_sa') {
        const events = [];
        const vybraneDni = (blocked.vybrane_dni || '').split(',').map(d => d.trim().toUpperCase());
        
        if (vybraneDni.length === 0) return [];
        
        const dayMap = { NE: 0, PO: 1, UT: 2, ST: 3, STV: 4, PI: 5, SO: 6 };
        const targetDays = vybraneDni.map(d => dayMap[d]).filter(d => d !== undefined);
        
        const startDate = new Date(blocked.opakovat_od || blocked.zaciatok.split(' ')[0]);
        const endDate = blocked.opakovat_do ? new Date(blocked.opakovat_do) : new Date(2099, 11, 31);
        
        const timeParts = blocked.zaciatok.split(' ');
        const startTime = timeParts.length > 1 ? timeParts[1] : '00:00:00';
        const endTimeParts = blocked.koniec.split(' ');
        const endTime = endTimeParts.length > 1 ? endTimeParts[1] : '23:59:00';
        
        const maxDate = new Date(startDate);
        maxDate.setDate(maxDate.getDate() + 365);
        const finalDate = endDate < maxDate ? endDate : maxDate;
        
        const currentDate = new Date(startDate);
        while (currentDate <= finalDate) {
          const dayOfWeek = currentDate.getDay();
          
          if (targetDays.includes(dayOfWeek)) {
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const dateStr = `${year}-${month}-${day}`;
            
            events.push({
              id: `blocked-${blocked.id}-${dateStr}`,
              title: `${blocked.nazov}`,
              start: `${dateStr} ${startTime}`,
              end: `${dateStr} ${endTime}`,
              allDay: false,
              display: 'block',
              className: options.className || 'blocked-event',
              classNames: options.classNames || ['blocked-event', 'recurring-blocked'],
              extendedProps: {
                type: 'blocked',
                data: blocked,
                isBlocked: true,
                isRecurring: true,
                ...(options.extendedProps || {})
              }
            });
          }
          
          currentDate.setDate(currentDate.getDate() + 1);
        }
        
        return events;
      }
      
      return {
        id: `blocked-${blocked.id}`,
        title: `${blocked.nazov}`,
        start: startTime,
        end: endTime,
        allDay: false,
        className: options.className || 'blocked-event',
        classNames: options.classNames || ['blocked-event'],
        extendedProps: {
          type: 'blocked',
          data: blocked,
          isBlocked: true,
          isAllDayBlocking: false,
          ...(options.extendedProps || {})
        }
      };
    }).flat();
};

export const getServiceColor = (serviceName) => {
  const hash = serviceName.split('').reduce((acc, char) => char.charCodeAt(0) + acc, 0);
  const colors = [
    { bg: '#eff6ff', border: '#93c5fd', text: '#1e40af' },
    { bg: '#f0fdf4', border: '#86efac', text: '#15803d' },
    { bg: '#fef3c7', border: '#fcd34d', text: '#b45309' },
    { bg: '#fce7f3', border: '#f9a8d4', text: '#be185d' },
    { bg: '#f3e8ff', border: '#d8b4fe', text: '#7c3aed' },
    { bg: '#ecfeff', border: '#67e8f9', text: '#0e7490' }
  ];
  return colors[hash % colors.length];
};
